import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClientHandlingErrorStatusCode, EHttpStatusCodeSuccess } from "@devowl-wp/api";
import { useStores } from "../store/root.js";
import { getClient } from "../util/api-fetch.js";
import { QueryKeys } from "../util/query-keys.js";
function useUntranslatableDelete() {
    const { rcbAuthenticationStore } = useStores();
    const queryClient = useQueryClient();
    const deleteMutation = useMutation(async ({ text, template: { type: templateType, identifier: templateIdentifier } })=>{
        const result = await getClient().template.untranslatable.delete({
            request: {
                text,
                template: {
                    type: templateType,
                    identifier: templateIdentifier
                }
            },
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
        switch(result.status){
            case EHttpStatusCodeSuccess.NoContent:
                return result.response;
            case ClientHandlingErrorStatusCode:
                throw result.error;
            default:
                throw result.response;
        }
    }, {
        onSuccess: ()=>{
            // Invalidate all untranslatables queries to refetch data
            queryClient.invalidateQueries(QueryKeys.getAllUntranslatables());
        }
    });
    return deleteMutation;
}
export { useUntranslatableDelete };
